<template>
  <v-container fluid>

    <v-layout align-center justify-start>
      <v-flex>
        <h2>Industry Statistics</h2>
      </v-flex>
      <v-flex shrink>
        <v-btn color="info" @click="refresh">Refresh</v-btn>
      </v-flex>
    </v-layout>

    <stacked-industry-chart
      :chart-name="'Leads Per Day'"
      :dataset-name="DatasetNames.LEADS_PER_DAY"
      :update-chart-data="updateChartData">
    </stacked-industry-chart>
    <stacked-industry-chart
      :chart-name="'Orders per Day by Industry'"
      :dataset-name="DatasetNames.ORDERS_PER_DAY"
      :update-chart-data="updateChartData">
    </stacked-industry-chart>
    <stacked-industry-chart
      :chart-name="'Average Options per Order per Day by Industry'"
      :dataset-name="DatasetNames.AVERAGE_OPTIONS"
      :update-chart-data="updateChartData">
    </stacked-industry-chart>
    <stacked-industry-chart
      :chart-name="'Unique Clients per Day by Industry'"
      :dataset-name="DatasetNames.UNIQUE_CLIENTS"
      :update-chart-data="updateChartData">
    </stacked-industry-chart>
    <stacked-industry-chart
      :chart-name="'Closes per Day by Industry'"
      :dataset-name="DatasetNames.CLOSES_PER_DAY"
      :update-chart-data="updateChartData">
    </stacked-industry-chart>

  </v-container>
</template>

<script>
import { DatasetNames } from '../../../config/industryDatasetNames';
import StackedIndustryChart from './StackedIndustryChart.vue';
import { mapActions, mapState } from 'vuex';
import Chart from 'chart.js';

export default {
  name: 'IndustryDashboard',
  components: { StackedIndustryChart },

  data() {
    return {
      DatasetNames,
      charts: {}
    };
  },

  computed: {
    ...mapState('industry', ['industryData'])
  },

  methods: {
    ...mapActions('industry', ['getData']),

    refresh() {
      Object.values(DatasetNames).forEach(this.updateChartData);
    },

    updateChartData(datasetName) {
      this.getData(datasetName)
        .then(() => {
          this.charts[datasetName].config.data = this.industryData[datasetName];
          this.charts[datasetName].update();
        });
    },

    setUpChart(datasetName) {
      this.charts[datasetName] = new Chart(datasetName, {
        type: 'line',
        data: {
          datasets: [],
          labels: []
        },
        options: {
          maintainAspectRatio: false,
          spanGaps: false,
          elements: {
            line: {
              tension: 0.000001
            }
          },
          scales: {
            yAxes: [{
              stacked: true
            }]
          },
          plugins: {
            datalabels: {
              display: false
            }
          }
        }
      });
    }
  },

  mounted() {
    Object.values(DatasetNames).forEach(this.setUpChart);
  },

  destroyed() {
    Object.values(DatasetNames).forEach(name => {
      this.charts[name].destroy();
    });
    this.charts = {};
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/reports/industry/IndustryDashboard.vue